import dayjs from "dayjs";
import { ALL_MONTHS } from "../consts";
import { formatDate } from "./formatDate";
import { safeCapitalize } from "./capitalize";

/**
 * Calculates the start and end date of a fiscal year based on given months and the current fiscal year.
 *
 * @param months - An array with two elements: the start and end month of the fiscal year (e.g., ["Feb", "Jan"])
 * @param currentFiscalYear - The current fiscal year string (e.g., "2024 Fiscal Year")
 * @returns An object with `fromDate` (start of fiscal year) and `endDate` (end of fiscal year)
 */
export const getFiscalYear = (months: string[], currentFiscalYear: string) => {
	const allMonths = [...ALL_MONTHS];
	const fiscalYear = Number(currentFiscalYear.substring(0, 4));
	const startMonthIndex = allMonths.indexOf(safeCapitalize(months[0]));
	const endMonthIndex = allMonths.indexOf(safeCapitalize(months[1]));

	const startYear = (startMonthIndex <= endMonthIndex) ? fiscalYear : fiscalYear - 1;
	const endYear = fiscalYear;

	return {
		fromDate: formatDate(startYear, startMonthIndex),
		endDate: dayjs(formatDate(endYear, endMonthIndex))
			.endOf("month")
			.format("YYYY-MM-DD"),
	};
};